module.exports = __webpack_public_path__ + "assets/img/jianyan.b0555491.png";